import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { navigateToSearchSuggestion } from 'owa-options-orchestration';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { OptionWithPath } from 'owa-options-store';

import * as React from 'react';

const styles = require('./OptionsFull.scss');

export interface OptionSearchSuggestionProps extends React.HTMLAttributes<HTMLButtonElement> {
    option: OptionWithPath;
}

export default observer(function OptionSearchSuggestion(props: OptionSearchSuggestionProps) {
    const onSuggestionClick = () => {
        let { option } = props;
        navigateToSearchSuggestion(option.categoryKey, option.subcategoryKey, option.key);
    };
    let { option } = props;
    return (
        <CommandButton
            {...props}
            text={loc(option.titleStringKey) as string}
            onClick={onSuggestionClick}
            className={styles.suggestion}
        />
    );
});
